import { Dictionary } from 'lodash';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { Team } from 'api/models';
import { useResourceManager } from 'components/organisms/resource-management/managers';
import { ProjectsWithMembers } from 'components/organisms/resource-management/types';
import { AllocatedMembers } from 'data/templates/projects';
import { updateAllocatedMembersAction } from 'data/templates/projects/actions';

interface Props {
  allocatedMembers: AllocatedMembers;
  project: ProjectsWithMembers;
  removeTeamFromUI: ReturnType<typeof useResourceManager>['removeTeamFromUI'];
  teamLookup: Dictionary<Team>;
}
interface Result {
  removeTeam: (teamId: number) => void;
}
export const useDeleteTeamsManager = ({
  project,
  removeTeamFromUI,
  allocatedMembers,
  teamLookup,
}: Props): Result => {
  const dispatch = useDispatch();

  const removeTeamFromState = useCallback(
    (teamId: number) => {
      dispatch(
        updateAllocatedMembersAction({
          users: allocatedMembers.users,
          teams: allocatedMembers.teams.filter((x) => x.teamId !== teamId),
        }),
      );
    },
    [allocatedMembers.teams, allocatedMembers.users, dispatch],
  );
  const removeTeam = useCallback(
    (teamId: number) => {
      removeTeamFromState(teamId);

      return removeTeamFromUI(
        project.projectId,
        teamLookup[teamId],
        undefined,
        true,
      );
    },
    [project.projectId, removeTeamFromUI, removeTeamFromState, teamLookup],
  );

  return {
    removeTeam,
  };
};
